<template>
    <div>
        <!-- Begin Page Content -->
        <div class="medical-records cart-section h-100">
            <div class="row h-100">
                <div class="col-12 mb-4 Order Confirmed h-100">
                    <div class="bg-white border-radius-5 p-5 Order h-100">
                        <div class="card border-0">
                            <div class="card-body p-0">
                                <div class="row justify-content-center order-confirmed successfully pt-3">
                                    <div class="col-md-7 text-center">
                                        <i class="icon icon-check mb-4"></i>
                                        <h3>You're all set</h3>
                                        <p>
                                            We're building your profile based on your unique genetic information. <br />
                                            It may take up to 15 minutes.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- End of Page Wrapper -->
    </div>
</template>
<script>
    export default {
        name: "dna-uploadedSuccess",
        data() {
            return {};
        },
        created(){
           this.pageName('DNA uploaded successfully')
        }
    };
</script>



// WEBPACK FOOTER //
// src/components/website/dna/dna-uploadSuccess.vue